import { ChangeDetectionStrategy, Component, TemplateRef, ViewChild, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { IrisProjectSelectEngine } from '../project-select.engine';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

interface Context {
  totalCount: number;
  shownCount: number;
}

@Component({
  selector: 'iris-project-select-dropdown-footer',
  templateUrl: './dropdown-footer.component.html',
  styles: `:host { display: none; }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
  ],
  standalone: true,
})
export class IrisProjectSelectDropdownFooterComponent {
  @ViewChild('template', { static: true }) template: TemplateRef<unknown>;
  readonly context$ = inject(IrisProjectSelectEngine).result$
    .pipe(
      map(page => ({
        totalCount: page.count,
        shownCount: page.elements.find(x => x.code === 'ALL')?.projects?.length ?? 0,
      })),
    );
}
